<template>
  <div>
    <!-- 头部部分充值明细 -->
    <div class="head">
      <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
        <el-form-item  prop="userId" v-if="adminShow">
          <el-cascader
            :placeholder="$t('app.rechargeList.form.agent')"
            ref="myCascader"
            :options="agentTree"
            :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
            :show-all-levels="false"
            clearable
            v-model="queryParams.userId"
            @change="search"
            filterable
          ></el-cascader>
        </el-form-item>
        <!-- <el-form-item  prop="userId" v-if="adminShow">
          <el-select v-model="queryParams.userId" filterable placeholder="代理商" @change="search" clearable >
            <el-option v-for="(item,index) in agentList" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId" />
          </el-select>
        </el-form-item> -->
        <el-form-item prop="orderMode" >
          <el-select v-model="queryParams.orderMode" filterable :placeholder="$t('app.rechargeList.form.paymentMethod')" @change="search" >
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="dateRange"
            style="width: 240px"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            :start-placeholder="$t('app.rechargeList.form.startDate')"
            :end-placeholder="$t('app.rechargeList.form.endDate')"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search"  @click="search">{{ $t('app.common.search') }}</el-button>
          <el-button icon="el-icon-refresh"  @click="resetQuery">{{ $t('app.common.reset') }}</el-button>
          <el-button type="primary" class="el-icon-download" @click="handleExport" v-hasPermi="['person:userAccount:export']"> {{ $t('app.common.export') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 内容部分 -->
    <div class="table">
      <el-table :data="tableData" border :header-cell-style ="{background: '#EEF1F6',color: '#606266'}">  
        <el-table-column type="index" :label="$t('app.rechargeList.table.serialNumber')" align="center" width="60px"></el-table-column>
        <el-table-column prop="orderId" :label="$t('app.rechargeList.table.orderId')" align="center" width="220px"></el-table-column>
        <el-table-column prop="username" :label="$t('app.rechargeList.table.nickname')" align="center" v-if="adminShow"></el-table-column>
        <el-table-column prop="company" :label="$t('app.rechargeList.table.agent')" align="center" v-if="adminShow"></el-table-column>
        <el-table-column prop="money" :label="$t('app.rechargeList.table.amount')" align="center" width="140px"></el-table-column>
        <el-table-column prop="orderMode" :label="$t('app.rechargeList.table.paymentMethod')" align="center">
          <template slot-scope="{row}">
            <span v-if="row.orderMode == '1'">{{ $t('app.rechargeList.paymentMethod.commissionRecharge') }}</span>
            <span v-else-if="row.orderMode == '2'">{{ $t('app.rechargeList.paymentMethod.officialAccountRecharge') }}</span>
            <span v-else-if="row.orderMode == '3'">{{ $t('app.rechargeList.paymentMethod.systemRecharge') }}</span>
            <span v-else-if="row.orderMode == '4'">{{ $t('app.rechargeList.paymentMethod.wechatRecharge') }}</span>
            <span v-else-if="row.orderMode == '5'">{{ $t('app.rechargeList.paymentMethod.alipayRecharge') }}</span>
            <span v-else>{{ $t('app.rechargeList.paymentMethod.balanceExpend') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="payTime" :label="$t('app.rechargeList.table.createTime')" align="center"></el-table-column>
        <el-table-column prop="operator" :label="$t('app.rechargeList.table.operator')" align="center" width="180px">
          <template slot-scope="{row}">
            <span v-if="row.operator == '1'">{{ $t('app.rechargeList.operator.userRecharge') }}</span>
            <span v-else-if="row.operator == '2'">{{ $t('app.rechargeList.operator.systemRecharge') }}</span>
            <span v-else>{{ $t('app.rechargeList.operator.agent') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('app.rechargeList.table.remark')" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { accountList,exportAccount } from "@/api/api.js";//充值明细
import { agentTreeList } from "@/api/api.js"; //代理商
export default {
  name:'first',
  data() {
    return{
      queryParams:{},
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      dateRange:[],
      options: [
        { value: 1, label: this.$t('app.rechargeList.paymentMethod.commissionRecharge')},
        { value: 3, label: this.$t('app.rechargeList.paymentMethod.systemRecharge')},
        { value: 4, label: this.$t('app.rechargeList.paymentMethod.wechatRecharge') },
        { value: 6, label: this.$t('app.rechargeList.paymentMethod.balanceExpend')},
        { value: 5, label: this.$t('app.rechargeList.paymentMethod.alipayRecharge')},
        { value: 2, label: this.$t('app.rechargeList.paymentMethod.officialAccountRecharge')},
      ],
      agentTree:[],
    }
  },
  computed: {
    adminShow : {
      get() {
          return this.$store.getters.user.userType =='1'
        }
    },
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params = {
        model:{
					...this.addDateRange(this.queryParams, this.dateRange),
				},
        page: this.page,
        pageSize: this.pageSize,
      };
      params.model.payType = "1"
      accountList(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    handleExport(){
      let params = {
        ...this.addDateRange(this.queryParams, this.dateRange),
        payType:'1'
      };
      exportAccount(params).then(res=>{
        this.$notify.info({
          title: this.$t('app.common.tips'),
          message: this.$t('app.rechargeList.notify.exportSuccess'),
          duration: 1000,
          offset:30
        });
      })

    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.dateRange = [];
      this.search();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    //代理商列表
    handleAgentTreeList(){
      agentTreeList().then(res => {
        this.agentTree = res.data.data;
      });
    },
  },
  created() {
    
  },
  mounted() {
    this.initData();
    if(this.adminShow){
      this.handleAgentTreeList();
    }
  },
};
</script>
<style scoped lang="less">
</style>


